import Headline from '../../../commons/src/components/headline'
import Paragraph from '../../../commons/src/components/paragraph'
import Container from '../components/container'
import PageContentLayout from '../components/page-content-layout'
import PageHeader from '../components/page-content-layout/PageHeader'

import PagePartial from './page-partial'

const ForbiddenPage = () => (
  <PagePartial>
    <PageContentLayout
      header={<PageHeader headline={<Headline size="l" label="Access denied" />} />}
    >
      <Container>
        <Paragraph>
          You have requested a page for which you do not have appropriate permission.
        </Paragraph>
      </Container>
    </PageContentLayout>
  </PagePartial>
)

export default ForbiddenPage
